
window.Spiral = window.Spiral || {};

window.Spiral.updateUtilityFreeShipping = (items_subtotal_price) => {
    const headerFreeShipping = document.querySelector('.js-header-free-shipping');

    if (headerFreeShipping) {
        const headerFreeShippingData = headerFreeShipping.dataset;
        const minCartValueForFreeShipping = headerFreeShippingData.minCartValue;
        const underThresholdMsg = headerFreeShippingData.underThresholdMsg;
        const aboveThresholdMsg = headerFreeShippingData.aboveThresholdMsg;
        const cartItemCount = headerFreeShippingData.cartItemCount;
        const cartDefaultMessage = headerFreeShippingData.defaultMessage;
    
    
        const cartSubtotal = items_subtotal_price;
        const shippingDifference = minCartValueForFreeShipping - cartSubtotal;
        const shippingDifferenceDecimal = (minCartValueForFreeShipping - cartSubtotal) / 100;
        const shopifyLocale = `${window.Shopify.locale}-${window.Shopify.country}`;
        const currentCurrency =  window.Shopify.currency.active;

        if (items_subtotal_price === 0) {
        if (headerFreeShipping.innerHTML.trim() !== cartDefaultMessage) {
            headerFreeShipping.innerHTML = cartDefaultMessage;
            headerFreeShipping.href = '/pages/delivery';
        }
        } else if (shippingDifference < 0) { // cart applicable for free shipping
            headerFreeShipping.innerHTML = aboveThresholdMsg;
            headerFreeShipping.href = '/cart';
        } else { // cart not applicable for free shipping
            // format the shipping difference to currency using .toLocaleString() for UK
            const shippingDifferenceFormatted = (shippingDifferenceDecimal).toLocaleString(shopifyLocale, { style: 'currency', currency: currentCurrency });
            let headerFreeShippingHTML = underThresholdMsg.replace('|||amount|||', `<strong>${shippingDifferenceFormatted}</strong>`);
            headerFreeShipping.innerHTML = headerFreeShippingHTML;
            // update link to sales page, if under 25 then sort by price
            headerFreeShipping.href = `/collections/sale${shippingDifferenceDecimal < 20 ? '?usf_sort=price' : ''}`;
        } 
    }
};
 
window.Spiral.updateCartFreeShipping = (items_subtotal_price) => {

    // find the div .cart-notification__free-shipping and get all of the data attributes then write the shipping difference to the div
    const freeShipping = document.querySelector('.cart__free-shipping');
    
    const freeShippingData = freeShipping.dataset;
    const minCartValueForFreeShipping = freeShippingData.minCartValue;
    const underThresholdMsg = freeShippingData.underThresholdMsg;
    const aboveThresholdMsg = freeShippingData.aboveThresholdMsg;
    
    const cartSubtotal = items_subtotal_price;
    const shippingDifference = minCartValueForFreeShipping - cartSubtotal;
    const shippingDifferenceDecimal = (minCartValueForFreeShipping - cartSubtotal) / 100;
    const shopifyLocale = `${window.Shopify.locale}-${window.Shopify.country}`;
    const currentCurrency =  window.Shopify.currency.active;
    
    if (items_subtotal_price === 0) {
        freeShipping.innerHTML = '';
        return;
    }

    if (shopifyLocale === 'en-GB' && window.meta.page.pageType === 'cart') {
        // update cart strip free shipping message
        if (shippingDifference < 0) { // cart applicable for free shipping
            freeShipping.innerHTML = `<strong class="fs-qualified">${aboveThresholdMsg}</strong>`;
        } else { // cart not applicable for free shipping
        // format the shipping difference to currency using .toLocaleString() for UK
        const shippingDifferenceFormatted = (shippingDifferenceDecimal).toLocaleString(shopifyLocale, { style: 'currency', currency: currentCurrency });
        let freeShippingHTML = underThresholdMsg.replace('|||amount|||', `<strong>${shippingDifferenceFormatted}</strong>`);
    
        freeShippingHTML += ` &ndash; Top up your cart with an <a href="/collections/sale${shippingDifferenceDecimal < 20 ? '?usf_sort=price' : ''}">amazing deal</a> from our sale!`;
    
        // calculate the percentage of the cart value to the min cart value for free shipping
        const percentageOfMinCartValue = ((minCartValueForFreeShipping - shippingDifference) / (minCartValueForFreeShipping)) * 100;

        freeShippingHTML += `<div class="cart__free-shipping-track"><div class="cart__free-shipping-status" style="width: ${percentageOfMinCartValue}%"></div></div>`;
        freeShipping.innerHTML = `<div class="fs-under-threshold">${freeShippingHTML}</div>`;
        }
    }
};

